export default __webpack_public_path__ + "static/media/GabMate.9fdc10fd.png";